import posthog from 'posthog-js'

export function usePostHog() {
  posthog.init(process.env.VUE_APP_POSTHOG_KEY, {
    api_host: 'https://us.i.posthog.com',
    defaults: '2026-01-30'
  })

  if (process.env.NODE_ENV === 'development') {
    posthog.opt_out_capturing()
  }

  return { posthog }
}